import styled from 'styled-components';
import Button from 'components/Button';

export const StyledButton = styled(Button)`
  color: #162952 !important;
  border: 1px solid #162952 !important;
  padding: 10px 15px !important;
`;
